<template>
  <a-dropdown
    overlay-class-name="mobile-menu"
    :trigger="['click']"
    @visible-change="toggleMenu"
  >
    <button class="mobile-menu__btn" type="button">
      <BaseIcon :name="!isMenuVisible ? 'burger' : 'close-modal'" />
    </button>

    <template #overlay>
      <a-menu @click="toggleMenu(false)">
        <a-menu-item
          v-for="menuItem in menuList"
          :key="menuItem.routeName"
          class="mobile-menu__item"
        >
          <router-link
            class="mobile-menu__link"
            active-class="mobile-menu__link--active"
            :to="{ name: menuItem.routeName }"
            :data-test="menuItem.qaSlug"
            exact-path
          >
            {{ menuItem.title }}
          </router-link>
        </a-menu-item>

        <!-- <a-menu-item class="mobile-menu__item"> 
          <button
            type="button"
            class="mobile-menu__link-btn"
            data-test="header-contact-us-link"
            @click="openContactUsModal"
          > 
            {{ $t('page_contact_us_head_title') }}
          </button>
        </a-menu-item> -->

        <a-menu-item class="mobile-menu__item">
          <router-link
            v-if="!user?.subscription?.is_premium"
            class="mobile-menu__link mobile-menu__link--upgrade"
            :to="{ name: 'Pricing' }"
            data-test="header-upgrade-to-pro-link"
            exact-path
          >
            <img src="@/assets/crown.svg" alt="premiumIcon" />
            {{ $t('form_button_get_premium') }}
          </router-link>
        </a-menu-item>

        <a-menu-item class="mobile-menu__item">
          <button
            v-if="!userEmpty"
            class="mobile-menu__link-btn"
            type="button"
            data-test="header-join-btn"
            @click="showLogoutModal"
          >
            <span class="mobile-menu__email"> {{ user.email }} </span>
            {{ $t('form_button_log_out') }}
          </button>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { Dropdown, Menu } from 'ant-design-vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'MobileMenu',

  components: {
    BaseIcon,
    AMenu: Menu,
    AMenuItem: Menu.Item,
    ADropdown: Dropdown,
  },

  data() {
    return {
      isMenuVisible: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['userEmpty', 'user']),
    menuList() {
      return this.userEmpty
        ? [
            {
              title: this.$t('page_home_head_title'),
              routeName: 'Home',
              qaSlug: 'header-home-link',
            },
            {
              title: this.$t('page_explore_plants_head_title'),
              routeName: 'ExplorePlants',
              qaSlug: 'header-explore-plants-link',
            },
            {
              title: this.$t('page_my_plants_head_title'),
              routeName: 'MyPlants',
              qaSlug: 'header-my-plants-link',
            },
            {
              title: this.$t('page_calendar_head_title'),
              routeName: 'Calendar',
              qaSlug: 'header-calendar-link',
            },
          ]
        : [
            {
              title: this.$t('page_home_head_title'),
              routeName: 'Home',
              qaSlug: 'header-home-link',
            },
            {
              title: this.$t('page_explore_plants_head_title'),
              routeName: 'ExplorePlants',
              qaSlug: 'header-explore-plants-link',
            },
            {
              title: this.$t('page_my_plants_head_title'),
              routeName: 'MyPlants',
              qaSlug: 'header-my-plants-link',
            },
            {
              title: this.$t('page_calendar_head_title'),
              routeName: 'Calendar',
              qaSlug: 'header-calendar-link',
            },
            {
              title: this.$t('page_settings_head_title'),
              routeName: 'Settings',
              qaSlug: 'header-settings-link',
            },
          ];
    },
  },

  methods: {
    toggleMenu(visible) {
      this.isMenuVisible = visible;

      visible
        ? document.body.classList.add('menu-opened')
        : document.body.classList.remove('menu-opened');
    },
    openContactUsModal() {
      this.toggleMenu(false);

      this.$store.dispatch('base/openModal', 'ContactUs');
    },
    showLoginModal() {
      this.toggleMenu(false);

      this.$store.dispatch('base/openModal', 'Authorization');
    },
    showLogoutModal() {
      this.toggleMenu(false);

      this.$store.dispatch('base/openModal', 'LogoutConfirm');
    },
  },
};
</script>

<style lang="scss">
.menu-opened {
  overflow: hidden;
}

.mobile-menu {
  $this: 'mobile-menu';
  width: 100%;
  height: calc(100vh - 64px);
  left: 0 !important;
  top: 64px !important;
  border-top: 1px solid $border_light;

  .ant-dropdown-content {
    height: 100%;
  }

  .ant-dropdown-menu {
    padding: 8px 0 40px 0;
    border-radius: 0;
    height: 100%;
    overflow-y: auto;
    box-shadow: none;
  }

  &__btn {
    @include reset-btn;
    line-height: 0;
    padding: 10px;

    .icon-burger {
      stroke: $light_purple;
      fill: $light_purple;
    }
  }

  &__item {
    padding: 12px 16px;
    text-align: center;
  }

  &__link {
    text-align: center;
    font-weight: 600;
    font-size: 17px;
    line-height: 34px;
    color: $plant_description !important;

    &--active,
    &--upgrade {
      color: $light_purple !important;
    }
    &--upgrade {
      background: #9252fa;
      border-radius: 8px;
      padding: 9px 16px;
      font-size: 13px;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: 0.25px;
      color: #ffffff !important;

      img {
        margin-right: 12px;
      }
    }
  }

  &__link-btn {
    @include reset-btn;
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 17px;
    line-height: 34px;
    color: $plant_description;
  }

  &__email {
    display: block;
    font-weight: 400;
    color: $light_purple;
    font-size: 16px;
    margin-top: 24px;
  }
}
</style>
